var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"player"},[_c('div',{staticClass:"float"},[_c('img',{staticStyle:{"width":"28px"},attrs:{"src":_vm.starIcon},on:{"click":_vm.collection}})]),_vm._l((_vm.element),function(e){return _c('video',{key:e,staticClass:"video-js vjs-default-skin",attrs:{"id":"video"}},[_vm._v("\n    you are browser not support html5.\n  ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }